import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=11262511&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=11262511&prod&lang=scss"
import style1 from "./ChatHistory.vue?vue&type=style&index=1&id=11262511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../worksheets/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11262511",
  null
  
)

export default component.exports